<template>
  <span class="applicant_title">{{ `${titleName} ${applicantNumber}【${applicantTitle}】` }}</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'JrApplicantTitle',
  props: {
    titleName: {
      type: String,
      required: true,
    },
    applicantNumber: {
      type: String,
      required: true,
    },
    applicantTitle: {
      type: String,
      required: true,
    },
  },
})
</script>
